<template>
    <div class="inner mb-5" id="amenities">
        <div class="p-4">
            <b-row>
                <b-col md="4">
                    <h3 class="display-3 position-sticky mb-4">Property amenities</h3>
                </b-col>
                <b-col md="8">
                    <b-row>
                        <b-col sm="6" class="mb-2" v-if="amenities.internet">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'wifi']" class="amenity-icon" />
                                Internet
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.internet">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                        <b-col sm="6" class="mb-2" v-if="amenities.businessservices">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'suitcase']" class="amenity-icon" />
                                Business services
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.businessservices">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                        <b-col sm="6" class="mb-2" v-if="amenities.parking_transportation">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'parking']" class="amenity-icon" />
                                Parking and transportation
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.parking_transportation">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                        <b-col sm="6" class="mb-2" v-if="amenities.food_drink">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'glass-cheers']" class="amenity-icon" />
                                Food and drink
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.food_drink">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                        <b-col sm="6" class="mb-2" v-if="amenities.accessibility">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fab', 'accessible-icon']" class="amenity-icon" />
                                Accessibility
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.accessibility">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                        <b-col sm="6" class="mb-2" v-if="amenities.thingstodo">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'ticket-alt']" class="amenity-icon" />
                                Things to do
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.thingstodo">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                        <b-col sm="6" class="mb-2" v-if="amenities.familyfriendly">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'users']" class="amenity-icon" />
                                Family friendly
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.familyfriendly">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                        <b-col sm="6" class="mb-2" v-if="amenities.conveniences">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'building']" class="amenity-icon" />
                                Conveniences
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.conveniences">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                        <b-col sm="6" class="mb-2" v-if="amenities.guestservices">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'concierge-bell']" class="amenity-icon" />
                                Guest services
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.guestservices">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                        <b-col sm="6" class="mb-2" v-if="amenities.pets">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'dog']" class="amenity-icon" />
                                Pets
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.pets">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                        <b-col sm="6" class="mb-2" v-if="amenities.safetysecurity">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'lock']" class="amenity-icon" />
                                Safety &amp; Security
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.safetysecurity">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                        <b-col sm="6" class="mb-2" v-if="amenities.more">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'check']" class="amenity-icon" />
                                More
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.more">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col md="4">
                    <h3 class="display-3 position-sticky mb-4">Room amenities</h3>
                </b-col>
                <b-col md="8">
                    <b-row>
                        <b-col sm="6" class="mb-2" v-if="amenities.room_bedroom">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'bed']" class="amenity-icon" />
                                Bedroom
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.room_bedroom">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                        <b-col sm="6" class="mb-2" v-if="amenities.room_entertainment">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'tv']" class="amenity-icon" />
                                Entertainment
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.room_entertainment">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                        <b-col sm="6" class="mb-2" v-if="amenities.room_bathroom">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'bath']" class="amenity-icon" />
                                Bathroom
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.room_bathroom">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                        <b-col sm="6" class="mb-2" v-if="amenities.room_food_drink">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'glass-cheers']" class="amenity-icon" />
                                Food and Drink
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.room_food_drink">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                        <b-col sm="6" class="mb-2" v-if="amenities.room_more">
                            <h3 class="display-4">
                                <font-awesome-icon :icon="['fas', 'check']" class="amenity-icon" />
                                More
                            </h3>
                            <ul class="list-unstyled">
                                <template v-for="amenity in amenities.room_more">
                                    <li :key="amenity">{{ $t(amenity) }}</li>
                                </template>
                            </ul>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { 
        faArrowLeft, 
        faWifi, 
        faSuitcase, 
        faParking, 
        faGlassCheers,
        faTicketAlt,
        faUsers,
        faConciergeBell,
        faBuilding,
        faCheck,
        faTv,
        faBath,
        faBed,
        faDog,
        faLock,
    } from '@fortawesome/free-solid-svg-icons'

    import { faAccessibleIcon } from '@fortawesome/free-brands-svg-icons'

    library.add(faArrowLeft)
    library.add(faWifi)
    library.add(faSuitcase)
    library.add(faParking)
    library.add(faGlassCheers)
    library.add(faAccessibleIcon)
    library.add(faTicketAlt);
    library.add(faUsers);
    library.add(faConciergeBell)
    library.add(faBuilding)
    library.add(faCheck)
    library.add(faTv)
    library.add(faBath)
    library.add(faBed)
    library.add(faDog)
    library.add(faLock)

    export default {
        name: 'Amenities',
        props: {
            amenities: {
                type: Object,
                required: true
            },
        },
    }
</script>

<style scoped>
    @media screen and (min-width:768px) {
        .amenity-icon{
            position:absolute;
            left:-20px;
            top:2px;
        }
    }
</style>
